'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getStorefront() {
    const response = await api.api({ method: 'get', url: 'storefront' })
    if (response.status === 200) return response.data
  },
  async updateSettings(settings, message = 'Storefront settings saved') {
    const response = await api.api({ method: 'put', url: 'storefront', body: settings })
    if (response.status === 200) {
      notify.alert.success(message)
      return response.data
    }
  },
  async getSections() {
    const response = await api.api({ method: 'get', url: 'storefront/sections' })
    if (response.status === 200) return response.data
    return []
  },
  async createSection(json) {
    const response = await api.api({ method: 'post', url: 'storefront/section', body: json })
    if (response.status === 201) {
      notify.alert.success('Section added')
      return response.data
    }
  },
  async updateSection(id, json, message = 'Section saved') {
    const response = await api.api({ method: 'put', url: 'storefront/section/' + id, body: json })
    if (response.status === 200) {
      if (message) notify.alert.success(message)
      return response.data
    }
  },
  async deleteSection(id) {
    const response = await api.api({ method: 'delete', url: 'storefront/section/' + id })
    if (response.status === 200) {
      notify.alert.success('Section removed')
      return true
    }
  },
  async reorderSections(order) {
    const response = await api.api({ method: 'post', url: 'storefront/sections/reorder', body: { order } })
    return response.status === 200
  },
  async createItem(sectionId, json) {
    const response = await api.api({ method: 'post', url: `storefront/section/${sectionId}/item`, body: json })
    if (response.status === 201) {
      notify.alert.success('Item added')
      return response.data
    }
  },
  async updateItem(id, json, message = 'Item saved') {
    const response = await api.api({ method: 'put', url: 'storefront/item/' + id, body: json })
    if (response.status === 200) {
      if (message) notify.alert.success(message)
      return response.data
    }
  },
  async deleteItem(id) {
    const response = await api.api({ method: 'delete', url: 'storefront/item/' + id })
    if (response.status === 200) {
      notify.alert.success('Item removed')
      return true
    }
  },
  async reorderItems(sectionId, order) {
    const response = await api.api({ method: 'post', url: `storefront/section/${sectionId}/items/reorder`, body: { order } })
    return response.status === 200
  },
}
